var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3292 3.28669L13.3301 3.28701C14.4835 3.6985 15.6803 3.97261 16.8965 4.10374L16.8996 4.10407C17.0424 4.11896 17.1772 4.18722 17.2768 4.29913C17.3767 4.41136 17.4335 4.55926 17.4334 4.71455V4.71514V9.21401C17.4334 9.21412 17.4334 9.21423 17.4334 9.21434C17.4328 10.7162 17.0361 12.1898 16.2852 13.4828C15.5344 14.7757 14.4571 15.8402 13.166 16.5675C13.1659 16.5676 13.1659 16.5676 13.1658 16.5677L10.2847 18.1896L10.2806 18.1919C10.1941 18.2412 10.0974 18.2667 9.99966 18.2667C9.90194 18.2667 9.80522 18.2412 9.7187 18.1919L9.71469 18.1896L6.83437 16.5677C6.83433 16.5676 6.83429 16.5676 6.83425 16.5676C5.54314 15.8403 4.46581 14.7757 3.71495 13.4828C2.96407 12.1898 2.56735 10.7162 2.56675 9.21434C2.56675 9.21423 2.56675 9.21412 2.56675 9.21401L2.56675 4.71514L2.56675 4.71465C2.56666 4.5593 2.62358 4.41135 2.72353 4.29911C2.8232 4.18719 2.95808 4.11897 3.10095 4.10414L3.10095 4.10415L3.10464 4.10375C4.32048 3.97252 5.517 3.69841 6.67004 3.28701L6.67096 3.28668C7.72911 2.90785 8.74397 2.41534 9.69821 1.81768L9.70566 1.81301C9.79599 1.76053 9.89745 1.73334 10.0001 1.73334C10.1067 1.73334 10.212 1.76267 10.3049 1.8192C11.2582 2.41625 12.2721 2.90825 13.3292 3.28669Z",
    stroke: "#C7CBD4",
    strokeWidth: 1.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#C7CBD4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 2,
    height: 8,
    rx: 1,
    transform: "rotate(90 14 9)",
    fill: "#C7CBD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayerMenu);
export default __webpack_public_path__ + "static/media/PayerMenu.13f738a92823592c56d9dfb3c54eddf9.svg";
export { ForwardRef as ReactComponent };